const de = {
    'Total': 'Gesamt',
    'Go to checkout': 'Zur Kasse gehen',
    'Coupon': 'Gutschein',
    'Email': 'E-mail',
    'Proceed': 'Weiter',
    'Select a shipping method to continue': 'Wähle eine Versandart, um fortzufahren',
    'Name': 'Name',
    'Last name': 'Nachname',
    'Street': 'Straße',
    'Zip code': 'Postleitzahl',
    'City': 'Stadt',
    'Country': 'Land',
    'State/Region': 'Bundesland/Region',
    'Change shipping address': 'Lieferadresse ändern',
    'Change billing address': 'Rechnungsadresse ändern',
    'Change payment method': 'Zahlungsmethode ändern',
    'Edit': 'Bearbeiten',
    'Select shipping method': 'Versandart wählen',
    'Select payment method': 'Zahlungsmethode wählen',
    'Additional services': 'Zusätzliche Dienstleistungen',
    'Apply': 'Anwenden',
    'Sign in': 'Login',
    'Password': 'Passwort',
    'I want to receive the <span>INVOICE</span>': 'Ich möchte die <span>RECHNUNG</span> erhalten',
    'Invoice requested': 'Rechnung angefordert',
    'Fiscal code': 'Steuernummer',
    'FC': 'St. -Nr',
    'Quantity': 'Menge',
    'Loading': 'Laden',
    'Remove': 'Entfernen',
    'Back': 'Rückwärts',
    '<strong>Add {tot}</strong> and we\'ll give you <strong>free</strong> shipping':
        '<strong>Füge {tot}</strong> hinzu und erhalte <strong>gratis</strong>Versand',
    'Shipping informations': 'Versandinformationen',
    'Shipping address': 'Lieferadresse',
    'Address': 'Adresse',
    'Company Name': 'Name des Unternehmens',
    'VAT Number': 'Umsatzsteuer-Identifikationsnummer',
    'PEC Address': 'PEC-Adresse',
    'SDI Code': 'SDI Code',
    'Are you sure you want to delete this item from cart?':
        'Bist du sicher, dass du diesen Artikel aus dem Warenkorb löschen möchtest?',
    'Cart': 'Warenkorb',
    'Shipping': 'Versand',
    'Email and telephone number': 'E-Mail und Telefonnummer',
    'Billing address': 'Rechnungsadresse',
    'Billing address is the same as the shipping address': 'Die Rechnungsadresse ist die gleiche wie die Lieferadresse',
    'Selected address has invalid fields': 'Ausgewählte Adresse hat ungültige Felder',
    'Continue as guest': 'Weiter als Gast',
    'or': 'oder',
    'Recover password': 'Passwort wiederherstellen',
    'Account creation': 'Konto erstellen',
    'Continue': 'Weiter',
    'Please wait': 'Bitte warten',
    'Close': 'Schließen',
    'Order placed': 'Die Bestellung wurde aufgegeben. Du wirst zur Bestellzusammenfassung weitergeleitet',
    'Send remainder': 'Passwort-Wiederherstellungs-E-Mail senden',
    'Password confirm': 'Passwort bestätigen',
    'Save address': 'Adresse speichern',
    'Street number': 'Hausnummer',
    'Select a payment method': 'Wähle eine Zahlungsmethode',
    'Payment method': 'Zahlungsmethode',
    'Error during registration': 'Fehler bei der Registrierung',
    'We have sent you an email to reset your password. Click on the link you will find inside.':
        'Wir haben dir eine E-Mail geschickt, um dein Passwort zurückzusetzen. Klicke auf den darin enthaltenen Link.',
    'Service unavailable, retry later': 'Dienst nicht verfügbar, später erneut versuchen',
    'Error, try to logout and login back to proceed with checkout': 'Fehler. Versuchen Sie, sich abzumelden und erneut anzumelden, um mit dem Bezahlen fortzufahren',
    'Ordered products': 'Bestellte Produkte',
    'No shipping methods available': 'Keine Versandarten verfügbar',
    'We\'re unable to send the password reset email':
        'Die E-Mail zum Zurücksetzen des Passworts konnte nicht gesendet werden. Bitte überprüfe die von dir eingegebene E-Mail',
    'Do you have a promotional code?': 'Hast du einen Rabattcode?',
    'Insert the code': 'Rabattcode einfügen',
    'Order summary': 'Zusammenfassung der Bestellung',
    'VAT': 'Mehrwertsteuer',
    'Sign up': 'Anmelden',
    'Already registered on': 'Es gibt bereits einen Account für',
    'Don\'t have an account yet?': 'Sie haben noch keinen Account?',
    'First time on': 'Das erste Mal bei',
    'Create your personal account.': 'Erstelle deinen persönlichen Account.',
    'Your Password': 'Ihr Passwort',
    'Your name': 'Dein Name',
    'Your last name': 'Dein Nachname',
    'Choose a password': 'Wähle ein Passwort',
    'Your email': 'Ihre E-Mail',
    'Or sign in with your email address': 'Oder melde dich mit deiner E-Mail-Adresse an',
    'Sign in with your email address': 'Mit deiner E-Mail-Adresse anmelden',
    'Do you already have an account?': 'Hast du bereits einen Account?',
    'Create an account': 'Einen Account erstellen',
    'Sign up with your email address': 'Registriere dich mit deiner E-Mail-Adresse',
    'Continue shopping': 'Einkauf fortsetzen',
    'Your cart is empty': 'Dein Warenkorb ist leer',
    'product': 'Produkt',
    'products': 'Produkte',
    'Shipping included': 'Inklusive Versand',
    'Choose a shipping address': 'Wähle eine Lieferadresse',
    'There aren\'t shipping methods for this address, insert/select another one':
        'Es gibt keine Versandmethoden für diese Adresse, gib eine andere ein/wähle eine andere aus',
    'Attention, the cost of shipments has been updated': 'Achtung, die Kosten für den Versand wurden aktualisiert',
    'Select an address': 'Eine Adresse auswählen',
    'Save new address to proceed': 'Neue Adresse speichern, um fortzufahren',
    'Create new address to proceed': 'Neue Adresse erstellen, um fortzufahren',
    'Insert a valid email address to proceed': 'Gib eine gültige E-Mail-Adresse ein, um fortzufahren',
    'Accept all agreements to proceed': 'Bedingungen akzeptieren, um fortzufahren',
    '<a href="{link}">Edit it</a> or insert/select another one':
        '<a href="{link}">Bearbeiten</a> oder andere Auswahl treffen',
    'Phone number': 'Handynummer',
    'Telephone number': 'Telefonnummer',
    'Contact details': 'Kontaktinformationen',
    'Address details': 'Adressdaten',
    'Add new address': 'Neue Adresse hinzufügen',
    'Enter Company Name': 'Firmenname eingeben',
    'Enter VAT Number': 'Umsatzsteuer-Identifikationsnummer eingeben',
    'Enter PEC Address': 'PEC-Adresse eingeben',
    'Enter your SDI code': 'Enter your SDI code',
    'Please check your order.': 'Bitte überprüfe deine Bestellung.',
    'By confirming your order, you accept our general terms and conditions as well as the information on security and data protection on www.passionebeauty.com.':
        'Mit der Bestätigung der Bestellung akzeptiere ich die AGBs sowie die Informationen zu Sicherheit und Datenschutz auf www.passionebeauty.com',
    'Loading payment form, please wait': 'Zahlungsformular wird geladen, bitte warten',
    'Available for shipment': 'Für den Versand bereit',
    'I understand': 'Ich verstehe',
    'Forgot Your Password?': 'Hast du dein Passwort vergessen?',
    'Step {step} of {steps}': 'Schritt {step} von {steps}',
    'This field is mandatory': 'Dieses Feld ist ein Pflichtfeld',
    'Enter at least one of the two fields': 'Mindestens eines der beiden Felder ausfüllen',
    'Sales conditions': 'Verkaufsbedingungen',
    'Ops! The payment for your last order <strong>was unsuccessful and will be automatically deleted within 20 minutes</strong>. To try again click below and the procedure will start again.':
        'Ups! Die Zahlung für deine letzte Bestellung <strong> war nicht erfolgreich und wird innerhalb von 20 Minuten automatisch gelöscht </strong>. Um es erneut zu versuchen, klicke unten und der Vorgang wird erneut gestartet.',
    'Do you prefer to return to visit the site and place your order later?':
        'Ziehst du es vor, später die Website erneut zu besuchen und deine Bestellung aufzugeben?',
    'Reorder': 'Nachbestellen',
    'Your last order has not been completed. If you want to add last order\'s items click on "Add" button':
        'Deine letzte Bestellung ist noch nicht abgeschlossen. Wenn du die Artikel der letzten Bestellung hinzufügen möchtest, klicke auf "Hinzufügen"',
    'Add': 'Hinzufügen',
    'Check the phone number: <strong>it must be a valid mobile phone</strong>.':
        'Überprüfe die Telefonnummer: <strong> es muss eine gültige Handynummer sein </strong>.',
    'Change telephone number': 'Telefonnummer ändern',
    'Telephone must be a valid italian mobile phone':
        'Die Handynummer muss in Deutschland, Österreich oder der Schweiz gültig sein',
    'Do you have a gift card?': 'Hast du einen Gutschein?',
    'Verify gift card': 'Gutschein überprüfen',
    'Current balance': 'Aktuelles Guthaben',
    'The gift card is invalid or empty. Please check the gift card and try again':
        'Der Gutschein ist ungültig oder leer. Bitte überprüfe ihn und versuche es erneut',
    'Gift card applied': 'Gutschein angewendet',
    'Gift card was removed because the total amount is too low':
        'Gutschein wurde entfernt, weil der Gesamtbetrag zu niedrig ist. Füge weitere Produkte hinzu, um den Gutschein zu verwenden',
    'No payment information required': 'Keine Zahlungsinformationen erforderlich',
    'Sign in with {social}': 'Anmelden mit {social}',
    'Added to wishlist': 'Zur Wunschliste hinzugefügt',
    'Do you want to add the product to your wish list before removing it?':
        'Möchtest du das Produkt zu deiner Wunschliste hinzufügen, bevor du es entfernst?',
    'Add to wishlist': 'Zur Wunschliste hinzufügen',
    'Please note! One or more products cannot be ordered. Please check the products highlighted in red in your shopping cart.':
        'Achtung! Eines oder mehrere Produkte können nicht bestellt werden. Bitte überprüfe die rot markierten Produkte in deinem Warenkorb.',
    'Payment': 'Zahlung',
    'Check': 'Überprüfung',
    'VAT {taxPercent}% included': 'MwSt {taxPercent}% inklusive',
    'Select': 'Wählen',
    'Change': 'Ändern',
    'Pickup Point': 'Abholpunkt',
    'Change pickup point': 'Abholpunkt ändern',
    'You have selected a different country, please choose your prefered shipping method':
        'Sie haben ein anderes Land ausgewählt, bitte wählen Sie Ihre bevorzugte Versandart',
    'Yes': 'Ja',
    'No': 'Nein',
    'Choose whether to have the invoice or not to proceed':
        'Wählen Sie, ob Sie die Rechnung erhalten möchten oder nicht, um fortzufahren',
    'Rabatt (Mehrwertsteuerrückerstattung)': 'Mehrwertsteuerrückerstattung',
    'Please enter your email address below to receive a password reset link.':
        'Bitte geben Sie Ihre E-Mail-Adresse ein, um einen Kennwort-Zurücksetzen-Link zu erhalten.',
    'To see your cart, first log in to your Passione Beauty account.':
        'Um Ihren Warenkorb anzuzeigen, melden Sie sich zunächst bei Ihrem Passione Beauty-Konto an.',
    'If you need further assistance.': 'Wenn Sie weitere Hilfe benötigen.',
    'Write to us': 'Schreib uns',
    'Registration completed successfully': 'Registrierung erfolgreich abgeschlossen',
    'View and track order': 'Bestellung anzeigen und verfolgen',
    'By completing this order you can earn {points}':
        'Durch den Abschluss dieser Bestellung können Sie {points} verdienen',
    'If you are registered with the Passione Club, with this order you will get {points}':
        'Wenn Sie im Passione Club registriert sind, erhalten Sie mit dieser Bestellung {points}',
    '{points} - completing order': '{points} - Bestellung abschließen',
    '{points} - bonus for in-app purchase': '{points} - Bonus für In-App-Käufe',
    'Used up': 'Aufgebraucht',
    'Sorry, we can\'t apply this service right now': 'Leider können wir diesen Service derzeit nicht nutzen',
    'There is already an account with this email address. If you are sure that it is your email address, <a href="{url}">click here</a> to get your password and access your account.':
        'Es gibt bereits ein Konto mit dieser E-Mail-Adresse. Ist das Ihre E-Mail-Adresse? Dann <a href="{url}"> Klicken Sie hier </a>, um Ihr Passwort anzufordern und Zugriff auf Ihr Konto zu bekommen.',
    'If you\'d like to use a Coupon, please remove the Gift Card first':
        'Wenn Sie einen Gutschein verwenden möchten, entfernen Sie bitte zuerst die Geschenkkarte',
    'Pay with a saved credit card': 'Bezahlen Sie mit einer hinterlegten Kreditkarte',
    'Expiration': 'Ablauf',
    'Pay with a new credit or debit card': 'Bezahlen Sie mit einer neuen Kredit- oder Debitkarte',
    'Save credit card (one click payment)': 'Kreditkarte speichern (One-Click-Zahlung)',
    'Sign up with {social}': 'Mit {social} anmelden',
    'Registering with Facebook is very fast. There is no need to remember other passwords - no commitments for the brain. Don\'t worry, we won\'t share any information about you and we won\'t post anything on your behalf.':
        'Die Registrierung mit Facebook geht sehr schnell. Du brauchst dir keine weiteren Passwörter zu merken. Keine Sorge, wir geben keine Informationen über dich weiter und veröffentlichen nichts in deinem Namen.',
    'Shipping Country': 'Lieferland',
    'Removing': 'Entfernen',
    'Free shipping': 'Gratis Versand',
    'Save for future use': 'Für zukünftige Verwendung aufbewahren',
    'This order will be associated to your sales code:': 'Diese Bestellung wird Ihrem Verkaufscode zugeordnet:',
    'Delete card': 'Karte löschen',
    'Card deleted.': 'Karte wurde gelöscht.',
    'Use another card or another payment method to continue.':
        'Verwende eine andere Karte oder eine alternative Zahlungsmethode, um fortzufahren.',
    'Try entering your card details again or use another payment method to continue.':
        'Versuche, die Kartendaten erneut einzugeben oder wähle eine andere Zahlungsmethode.',
    'There was an error deleting your card, please try again later':
        'Beim Löschen Ihrer Karte ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut',
    'Or register with your e-mail address': 'Oder registriere dich mit deiner E-Mail Adresse',
    'ReCaptcha validation failed, please try again':
        'Die ReCaptcha-Validierung ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
    'This site is protected by reCAPTCHA and the Google <a href="{privacyPolicyLink}">Privacy Policy</a> and <a href="{termsOfServiceLink}">Terms of Service</a> apply.':
        'Diese Website ist durch reCAPTCHA geschützt und es gelten die <a href="{privacyPolicyLink}">Datenschutzerklärung</a> und <a href="{termsOfServiceLink}">Nutzungsbedingungen</a> von Google.',
    'Forgot Password?': 'Passwort vergessen?',
    'Conditions of sale for training courses': 'Verkaufsbedingungen für Schulungen',
    'Previously it was: {omnibusPrice} -{omnibusPercentage}': 'früher: {omnibusPrice} -{omnibusPercentage}',
    'How to read prices': 'Wie man Preise liest',
    'Here is an example to understand what the prices you find mean':
        'Hier ist ein Beispiel, um zu verstehen, was die Preise bedeuten',
    'This is the original price of the item without discounts (list price)':
        'Dies ist der Ursprungspreis des Artikels ohne Rabatte (Listenpreis)',
    'This is the currently active discount on the item applied to the list price price expressed as a percentage':
        'Dies ist der derzeit aktive Rabatt auf den Artikel, der auf den Listenpreis angewendet wird, ausgedrückt in Prozent',
    'This is the current item price with discount applied and VAT included':
        'Dies ist der aktuelle Preis des Artikels mit angewandtem Rabatt und inkl. MwSt.',
    'This is the lowest price the item had in the last 30 days before it was discounted':
        'Dies ist der niedrigste Preis, den der Artikel in den letzten 30 Tagen vor der Rabattierung hatte',
    'Telephone prefix': 'Telefonvorwahl',
    'Telephone without prefix': 'Telefon ohne Vorwahl',
    'Choose whether you have a VAT number or are a small business':
        'Wählen Sie aus, ob Sie eine Umsatzsteuer-Identifikationsnummer haben oder ein Kleinunternehmen sind',
    'Card': 'Kreditkarte',
};

export default de;
export const deValidation = {
    name: 'it',
    messages: {
        '_default': (e: any) => {
            return `Der Wert des Feldes ${e} ist ungültig.`;
        },
        'after': (e: any, n: any) => {
            return `Das Feld ${e} muss nach ${n[0]} stehen.`;
        },
        'alpha': (e: any) => {
            return `Das Feld ${e} darf nur alphabetische Zeichen enthalten.`;
        },
        'alpha_dash': (e: any) => {
            return `Das Feld ${e} darf sowohl alphanumerische Zeichen als auch Bindestriche und Unterstriche enthalten.`;
        },
        'alpha_num': (e: any) => {
            return `Das Feld ${e} darf nur alphanumerische Zeichen enthalten.`;
        },
        'alpha_spaces': (e: any) => {
            return `Das ${e}-Feld darf nur alphanumerische Zeichen sowie Leerzeichen enthalten.`;
        },
        'before': (e: any, n: any) => {
            return `Das ${e}-Feld muss vor ${n[0]} stehen.`;
        },
        'between': (e: any, n: any) => {
            return `Das ${e}-Feld muss vor ${n[0]} stehen.`;
        },
        'confirmed': (e: any, n: any) => {
            return `Das Feld ${e} stimmt nicht mit ${n[0]} überein.`;
        },
        'credit_card': (e: any) => {
            return `Das Feld ${e} ist ungültig.`;
        },
        'date_between': (e: any, n: any) => {
            return `Das ${e}-Feld muss zwischen ${n[0]} und ${n[1]} liegen.`;
        },
        'date_format': (e: any, n: any) => {
            return `Das ${e}-Feld muss im Format ${n[0]} vorliegen.`;
        },
        'decimal': (e: any, n: any) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-void, no-param-reassign
            void 0 === n && (n = []);
            let r = n[0];
            // eslint-disable-next-line no-return-assign
            return (
                // eslint-disable-next-line no-void
                void 0 === r && (r = '*'),
                    `Das Feld ${e} muss numerisch sein und darf${r && r !== '*' ? ` ${r}` : ''} Dezimalpunkte enthalten.`
            );
        },
        'digits': (e: any, n: any) => {
            return `Das Feld ${e} muss numerisch sein und genau ${n[0]} Ziffern enthalten.`;
        },
        'dimensions': (e: any, n: any) => {
            return `Das Feld ${e} muss ${n[0]} x ${n[1]} sein.`;
        },
        'email': (e: any) => {
            return `Das Feld ${e} muss eine gültige E-Mail-Adresse sein.`;
        },
        'excluded': (e: any) => {
            return `Das Feld ${e} muss einen gültigen Wert haben.`;
        },
        'ext': (e: any) => {
            return `Das Feld ${e} muss eine gültige Datei sein.`;
        },
        'image': (e: any) => {
            return `Das Feld ${e} muss ein Bild sein.`;
        },
        'included': (e: any) => {
            return `Das Feld ${e} muss einen gültigen Wert haben.`;
        },
        'ip': (e: any) => {
            return `Das Feld ${e} muss eine gültige IP-Adresse sein.`;
        },
        'length': (e: any, n: any) => {
            const r = n[0];
            const o = n[1];
            return o
                ? `Die Länge des Feldes ${e} muss zwischen ${r} und ${o} liegen.`
                : `Die Länge des Feldes ${e} muss ${r} sein.`;
        },
        'max': (e: any, n: any) => {
            return `Das Feld ${e} darf nicht länger als ${n[0]} Zeichen sein.`;
        },
        'c': (e: any, n: any) => {
            return `Das Feld ${e} muss kleiner oder gleich ${n[0]} sein".`;
        },
        'mimes': (e: any) => {
            return `Das Feld ${e} muss einen gültigen Dateityp haben.`;
        },
        'min': (e: any, n: any) => {
            return `Das Feld ${e} muss mindestens ${n[0]} Zeichen enthalten.`;
        },
        'min_value': (e: any, n: any) => {
            return `Das Feld ${e} muss größer als oder gleich ${n[0]} sein".`;
        },
        'numeric': (e: any) => {
            return `Das Feld ${e} darf nur numerische Zeichen enthalten.`;
        },
        'regex': (e: any) => {
            return `Das ${e}-Feld hat kein gültiges Format.`;
        },
        'required': (e: any) => {
            return `Das Feld ${e} ist erforderlich.`;
        },
        'size': (e: any, n: any) => {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            return `Das Feld ${e} muss kleiner sein als ${((e) => {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const n = 1024;
                // eslint-disable-next-line no-cond-assign, no-param-reassign
                const r = (e = Number(e) * n) === 0 ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / n ** r).toFixed(2));
                const v = 1 * f;
                return `${v.toFixed(2)} ${['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][r]}`;
            })(n[0])}.`;
        },
        'url': (e: any) => {
            return `Das ${e}-Feld ist keine gültige URL.`;
        },
        'validate-piva-cf': () => {
            return 'Mehrwertsteuernummer/Steuerkennzeichen ungültig.';
        },
        'validate-regionid': () => {
            return 'Das Feld Bundesland/Region ist erforderlich.';
        },
        'validate-password-wf': () => {
            return 'Die Mindestlänge dieses Feldes muss gleich oder größer als {1} Zeichen sein. Führende und nachfolgende Leerzeichen werden ignoriert. Überprüfe, dass mindestens 2 der folgenden 3 Bedingungen erfüllt sind: mindestens ein Großbuchstabe, mindestens eine Zahl, mindestens ein Sonderzeichen.';
        },
        'validate-password-wf-length': () => {
            return 'Die Mindestlänge dieses Feldes muss gleich oder größer als {1} Zeichen sein. Führende und nachfolgende Leerzeichen werden ignoriert.';
        },
        'validate-password-wf-character': () => {
            return 'Überprüfe auf mindestens 2 der folgenden 3 Bedingungen: mindestens ein Großbuchstabe, mindestens eine Zahl, mindestens ein Sonderzeichen.';
        },
        'validate-length': (e: any) => {
            return `Achtung, das Feld ${e} muss {1} Zeichen lang sein.`;
        },
        'validate-fiscal-code': () => {
            return 'Die Steuernummer muss genau 11 Zeichen lang sein.';
        },
        'validate-telephone-without-prefix': () => {
            return 'Bitte geben Sie eine gültige Telefonnummer an, darf das Präfix nicht enthalten (z. B. +49).';
        },
        'validate-foreign-country-telephone-without-prefix': () => {
            return 'Bitte geben Sie eine gültige Telefonnummer an, darf das Präfix nicht enthalten (z. B. +49).';
        },
        'validate-vat-number': () => {
            return 'Bitte geben Sie eine gültige Umsatzsteuer-Identifikationsnummer an, die "DE" gefolgt von einer 9-stelligen Nummer enthalten muss (z. B. DE123456789).';
        }
    },
    attributes: {}
};
